import { ToggleGroupField } from '@components/ToggleGroupField/ToggleGroupField';
import { Controller, useFormContext } from 'react-hook-form';
import type { ReportFiltersField, ReportFiltersValues } from '../../reportFilters.types';

type ToggleGroupFilterFieldConfig = Extract<
  ReportFiltersField,
  { type: 'toggle-group' }
>;

interface ToggleGroupFilterFieldProps {
  field: ToggleGroupFilterFieldConfig;
}

export const ToggleGroupFilterField = ({
  field,
}: ToggleGroupFilterFieldProps): React.ReactElement => {
  const { control } = useFormContext<ReportFiltersValues>();

  return (
    <Controller
      control={control}
      name={field.id}
      render={({ field: controllerField }) => (
        <ToggleGroupField
          label={field.label}
          value={controllerField.value ?? ''}
          options={field.options}
          onValueChange={controllerField.onChange}
        />
      )}
    />
  );
};
